import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';
import _ from 'lodash';

import { api } from '@/api';
import { PATHS } from '@/common';
import { Pagination, PaginationParams } from '@/common/types';
import { IClaimDtoClaimStatusEnum } from '@/types';

import { useGetEmployeeId } from '../../hooks';

interface ClaimPayload {
  claim_id?: number;
  provider_name?: string;
  service_id?: number;
  service_on?: string;
  requested_amount?: number;
}

interface Claim {
  claimId?: string;
  providerName?: string;
  serviceId?: string;
  serviceOn?: string;
  requestedAmount?: number;
}

interface Props extends Partial<PaginationParams> {
  disabled?: boolean;
}

const useClaimsSearchParticipantQuery = ({ page, perPage, disabled }: Props) => {
  const employeeId = useGetEmployeeId();

  const payload = {
    claim_status: [IClaimDtoClaimStatusEnum.NEEDS_HELP],

    pagination: {
      page: page && page >= 0 ? page - 1 : 0,
      page_size: perPage || 10,
    },
  };

  const { data, isLoading } = useQuery(
    [PATHS.CLAIMS_SEARCH_PARTICIPANT, page, perPage],
    () =>
      api.post<Pagination<ClaimPayload>>(
        // TODO: this url is missed in api aggregator
        PATHS.CLAIMS_SEARCH_PARTICIPANT,
        {
          ...payload,
          employee_ids: [_.toNumber(employeeId)],
        },
        {
          params: {},
        }
      ),
    {
      enabled: !disabled && !!employeeId,
    }
  );

  const claims: Claim[] = useMemo(
    () =>
      data?.data?.content?.map((claim) => ({
        claimId: toString(claim?.claim_id),
        providerName: claim?.provider_name,
        serviceId: toString(claim?.service_id),
        serviceOn: claim?.service_on,
        requestedAmount: claim?.requested_amount,
      })) || [],
    [data]
  );

  return {
    claims,
    total: data?.data?.totalElements || 0,
    isLoading,
  };
};

export default useClaimsSearchParticipantQuery;
